/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Drag_HintInputs */

const vi_sidebar_layout_drag_hint = /** @type {(inputs: Sidebar_Layout_Drag_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giữ và kéo biểu tượng để sắp xếp`)
};

/**

* @param {Sidebar_Layout_Drag_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_drag_hint = /** @type {((inputs?: Sidebar_Layout_Drag_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Drag_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_drag_hint(inputs)
});